/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../../common";
import type {
  MockDecoder,
  MockDecoderInterface,
} from "../../../contracts/test/MockDecoder";

const _abi = [
  {
    inputs: [],
    name: "CalldataOutOfBounds",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "parent",
            type: "uint8",
          },
          {
            internalType: "enum AbiType",
            name: "paramType",
            type: "uint8",
          },
          {
            internalType: "enum Operator",
            name: "operator",
            type: "uint8",
          },
          {
            internalType: "bytes",
            name: "compValue",
            type: "bytes",
          },
        ],
        internalType: "struct ConditionFlat[]",
        name: "conditions",
        type: "tuple[]",
      },
    ],
    name: "inspect",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "location",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "location",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "size",
                type: "uint256",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "location",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "size",
                    type: "uint256",
                  },
                  {
                    components: [
                      {
                        internalType: "uint256",
                        name: "location",
                        type: "uint256",
                      },
                      {
                        internalType: "uint256",
                        name: "size",
                        type: "uint256",
                      },
                      {
                        components: [
                          {
                            internalType: "uint256",
                            name: "location",
                            type: "uint256",
                          },
                          {
                            internalType: "uint256",
                            name: "size",
                            type: "uint256",
                          },
                          {
                            components: [
                              {
                                internalType: "uint256",
                                name: "location",
                                type: "uint256",
                              },
                              {
                                internalType: "uint256",
                                name: "size",
                                type: "uint256",
                              },
                            ],
                            internalType: "struct MockDecoder.PP6[]",
                            name: "children",
                            type: "tuple[]",
                          },
                        ],
                        internalType: "struct MockDecoder.PP5[]",
                        name: "children",
                        type: "tuple[]",
                      },
                    ],
                    internalType: "struct MockDecoder.PP4[]",
                    name: "children",
                    type: "tuple[]",
                  },
                ],
                internalType: "struct MockDecoder.PP3[]",
                name: "children",
                type: "tuple[]",
              },
            ],
            internalType: "struct MockDecoder.PP2[]",
            name: "children",
            type: "tuple[]",
          },
        ],
        internalType: "struct MockDecoder.PP1",
        name: "r",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        components: [
          {
            internalType: "enum AbiType",
            name: "_type",
            type: "uint8",
          },
          {
            internalType: "uint256[]",
            name: "fields",
            type: "uint256[]",
          },
        ],
        internalType: "struct AbiTypeTree[]",
        name: "typeTree",
        type: "tuple[]",
      },
    ],
    name: "inspectRaw",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "location",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "location",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "size",
                type: "uint256",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "location",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "size",
                    type: "uint256",
                  },
                  {
                    components: [
                      {
                        internalType: "uint256",
                        name: "location",
                        type: "uint256",
                      },
                      {
                        internalType: "uint256",
                        name: "size",
                        type: "uint256",
                      },
                      {
                        components: [
                          {
                            internalType: "uint256",
                            name: "location",
                            type: "uint256",
                          },
                          {
                            internalType: "uint256",
                            name: "size",
                            type: "uint256",
                          },
                          {
                            components: [
                              {
                                internalType: "uint256",
                                name: "location",
                                type: "uint256",
                              },
                              {
                                internalType: "uint256",
                                name: "size",
                                type: "uint256",
                              },
                            ],
                            internalType: "struct MockDecoder.PP6[]",
                            name: "children",
                            type: "tuple[]",
                          },
                        ],
                        internalType: "struct MockDecoder.PP5[]",
                        name: "children",
                        type: "tuple[]",
                      },
                    ],
                    internalType: "struct MockDecoder.PP4[]",
                    name: "children",
                    type: "tuple[]",
                  },
                ],
                internalType: "struct MockDecoder.PP3[]",
                name: "children",
                type: "tuple[]",
              },
            ],
            internalType: "struct MockDecoder.PP2[]",
            name: "children",
            type: "tuple[]",
          },
        ],
        internalType: "struct MockDecoder.PP1",
        name: "r",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "offset",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "size",
        type: "uint256",
      },
    ],
    name: "pluck",
    outputs: [
      {
        internalType: "bytes",
        name: "result",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type MockDecoderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MockDecoderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MockDecoder__factory extends ContractFactory {
  constructor(...args: MockDecoderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      MockDecoder & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): MockDecoder__factory {
    return super.connect(runner) as MockDecoder__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockDecoderInterface {
    return new Interface(_abi) as MockDecoderInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): MockDecoder {
    return new Contract(address, _abi, runner) as unknown as MockDecoder;
  }
}
